import { createSlice } from "@reduxjs/toolkit";
import {
  addTask,
  deleteTask,
  getTasks,
  getTasksByPhaseId,
  updateTask,
} from "./thunk";

interface TaskStateType {
  tasks: Array<any>;
  loading: boolean;
  error?: string | object | null | undefined | unknown;
}
export const initialState: TaskStateType = {
  tasks: [],
  loading: false,
  error: {},
};

const TaskSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    resetTasks: (state: any) => {
      state.tasks = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(getTasks.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(getTasks.fulfilled, (state: any, action: any) => {
      state.tasks = action.payload;
      state.loading = false;
    });
    builder.addCase(getTasks.rejected, (state, action) => {
      state.error = action.payload || null;
      state.loading = false;
    });
    builder.addCase(addTask.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(addTask.fulfilled, (state: any, action: any) => {
      state.tasks.push(action.payload);
      state.loading = false;
    });
    builder.addCase(addTask.rejected, (state, action) => {
      state.error = action.payload || null;
      state.loading = false;
    });
    builder.addCase(updateTask.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(updateTask.fulfilled, (state: any, action: any) => {
      state.tasks = state.tasks.map((task: any) =>
        task.id === action.payload.id ? { ...task, ...action.payload } : task
      );
      state.loading = false;
    });
    builder.addCase(updateTask.rejected, (state, action) => {
      state.error = action.payload || null;
      state.loading = false;
    });
    builder.addCase(deleteTask.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(deleteTask.fulfilled, (state: any, action: any) => {
      state.tasks = state.tasks.filter(
        (task: any) => task.id !== action.payload
      );
      state.loading = false;
    });
    builder.addCase(deleteTask.rejected, (state, action) => {
      state.error = action.payload || null;
      state.loading = false;
    });
    builder.addCase(getTasksByPhaseId.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(getTasksByPhaseId.fulfilled, (state: any, action: any) => {
      state.tasks = action.payload;
      state.loading = false;
    });
    builder.addCase(getTasksByPhaseId.rejected, (state, action) => {
      state.error = action.payload || null;
      state.loading = false;
    });
  },
});

export const { resetTasks } = TaskSlice.actions;
export default TaskSlice.reducer;
